__turbopack_context__.v({
  "button": "layout-module__IFDfyq__button",
  "imageContainer": "layout-module__IFDfyq__imageContainer",
  "infoModalContainer": "layout-module__IFDfyq__infoModalContainer",
  "infoModalDescription": "layout-module__IFDfyq__infoModalDescription",
  "infoModalTitle": "layout-module__IFDfyq__infoModalTitle",
  "pricingModal": "layout-module__IFDfyq__pricingModal",
});
